<template>
	<div class="receipt_list">
		<el-form :inline="true" :model="select" class="demo-form-inline" @keyup.enter.native="search">
			<el-form-item label="小区名称">
				<el-input v-model="select.community_name" placeholder="小区名称" style="width:120px;" :maxlength="12"></el-input>
			</el-form-item>
			<el-form-item label="户号">
				<el-input v-model="select.account" placeholder="户号" style="width:120px;" :maxlength="12"></el-input>
			</el-form-item>
			<!-- <el-form-item label="表号">
				<el-input v-model="select.code" placeholder="表号" style="width:120px;" :maxlength="12"></el-input>
			</el-form-item> -->
			<el-form-item label="选择开始日期">
				<el-date-picker v-model="select.startTime" type="date" placeholder="选择开始日期" style="width: 150px;">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="选择结束日期">
				<el-date-picker v-model="select.endTime" type="date" placeholder="选择结束日期" style="width: 150px;">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="发票类型">
				<el-select v-model="select.receiptType" placeholder="请选择" style="width: 160px;">
					<el-option v-for="item in receipts" :key="item.id" :label="item.value" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="开票类型">
				<el-select v-model="select.type" placeholder="请选择" style="width: 130px;">
					<el-option v-for="item in types" :key="item.id" :label="item.value" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="状态">
				<el-select v-model="select.status" placeholder="请选择" style="width: 100px;">
					<el-option v-for="item in statuss" :key="item.id" :label="item.value" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="配送方式">
				<el-select v-model="select.sendType" placeholder="请选择" style="width: 100px;">
					<el-option v-for="item in sendTypes" :key="item.id" :label="item.value" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<!--class="add_meter_code"-->
			<el-form-item>
				<el-button type="primary" @click="search">查询</el-button>
				<el-button type="primary" @click="resetting">重置</el-button>
				<el-button type="primary" @click="downreceipt()" >导出</el-button>
			</el-form-item>
		</el-form>
		<div class="receipt_list_table">
			<el-table :data="lists" border style="width:1652px;text-align:center;margin-bottom: 10px;font-size: 12px; " v-on:sort-change="sortChange">
				<el-table-column prop="community_name" label="小区" width="206" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="receipt_type" label="发票类型" width="187" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="type" label="开票类型" width="171" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="total_money" label="金额（元）" width="193" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="" label="状态" width="100" align="center" sortable="custom">
					<template scope="scope">
						<el-tag v-if="scope.row.status == '未开'" type="gray">未开</el-tag>
						<el-tag v-if="scope.row.status == '已开'" type="primary">已开</el-tag>
						<el-tag v-if="scope.row.status == '已取'" type="success">已取</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="create_time" label="创建时间" width="218" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="send_type" label="配送方式" width="170" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="account" label="户号" width="191" align="center" sortable="custom">
				</el-table-column>
				<!-- <el-table-column prop="meter_code" label="表号" width="191" align="center" sortable="custom">
				</el-table-column> -->
				<el-table-column prop="sumbit" label="操作" width="215" align="center">
					<template scope="scope">
						<el-button type="primary" size="mini" @click="changeReceipt(scope.row)" v-show="search_data">查看详情</el-button>
						<el-button type="primary" size="mini" @click="changeReceiptEdit(scope.row)" v-show="search_data">修改状态</el-button>
					</template>
				</el-table-column>

			</el-table>
			<el-pagination @current-change="handleCurrentChange" :page-size="pageSize" layout="total,prev, pager, next" :total="total">
			</el-pagination>
		</div>
		<receiptInfo v-bind:infoData="info_data" v-if="infoShow" v-on:closeinfo="closeInfo"></receiptInfo>
		<receiptEdit v-bind:receiptId="editId" v-if="editShow" v-on:closeedit="closeEdit"></receiptEdit>
	</div>
</template>

<script>
	import receiptInfo from '@/components/receiptInfo'
	import receiptEdit from '@/components/receiptEdit'
	export default {
		name: 'receipt-list',
		data() {
			return {
				select: {
					account: '',
					// code: '',
					startTime: '',
					endTime: '',
					receiptType: '',
					type: '',
					status: '',
					sendType: '',
					community_name:'',
				},
				search_data: false,
				pageSize: 15,
				total: 0,
				currentPage: '',
				info_data: '',
				editId: '',
				infoShow: false,
				editShow: false,
				order:'',
				prop:'',
				lists: [{
						receipt_id: '',
						receipt_type: '',
						type: '',
						total_money: '',
						status: '',
						create_time: '',
						send_type: '',
						// meter_code: '',
						account: '',
						address:'',
					}

				],
				receipts: [{
						id: '1',
						value: '增值税普通发票'
					},
					{
						id: '2',
						value: '增值税专用发票'
					}
				],
				types: [{
						id: '1',
						value: '个人'
					},
					{
						id: '2',
						value: '公司'
					},

				],
				statuss: [{
						id: '0',
						value: '未开'
					},
					{
						id: '1',
						value: '已开'
					},
					{
						id: '2',
						value: '已取'
					},
				],
				sendTypes: [{
						id: '1',
						value: '自取'
					},
					{
						id: '2',
						value: '邮寄'
					},
				]
			}
		},
		mounted:function(){
			this.search()
		},
		methods: {
			sortChange(item) {
				var order = item.order
				var prop = item.prop
				this.order = order
				this.prop = prop
				let account = this.select.account
				// let code = this.select.code
				let startTime = this.select.startTime
				let endTime = this.select.endTime
				let receiptType = this.select.receiptType
				let type = this.select.type
				let status = this.select.status
				let sendType = this.select.sendType
				let page = this.currentPage
				this.$jssdk.receipt.list({
					receipt_type: receiptType,
					type: type,
					status: status,
					send_type: sendType,
					account: account,
					// meter_code: code,
					start_time: startTime,
					end_time: endTime,
					is_export: '0',
					sort_by: prop,
					sort_to: order
				}, (data) => {
					this.lists = data.receiptList.data
					this.total = data.receiptList.total
					page = data.receiptList.page
					this.search_data = true
				},(err) =>{
					 this.$message({
						type:'warning',
						message:err.msg,
						duration:1000
					})
				})
			},
			search() {
				let account = this.select.account
				// let code = this.select.code
				let startTime = this.select.startTime
				let endTime = this.select.endTime
				let receiptType = this.select.receiptType
				let type = this.select.type
				let status = this.select.status
				let sendType = this.select.sendType
				var community_name = this.select.community_name
				let page = this.currentPage
				this.$jssdk.receipt.list({
					receipt_type: receiptType,
					type: type,
					status: status,
					send_type: sendType,
					account: account,
					// meter_code: code,
					start_time: startTime,
					end_time: endTime,
					is_export: '0',
					community_name:community_name
				}, (data) => {
					this.lists = data.receiptList.data
					this.total = data.receiptList.total
					page = data.receiptList.page
					this.search_data = true

				})
			},
			downreceipt() {
				let account = this.select.account
				// let code = this.select.code
				let startTime = this.select.startTime
				let endTime = this.select.endTime
				let receiptType = this.select.receiptType
				let type = this.select.type
				let status = this.select.status
				let sendType = this.select.sendType
				let page = this.currentPage
				var community_name = this.select.community_name
				this.$jssdk.receipt.list({
					receipt_type: receiptType,
					type: type,
					status: status,
					send_type: sendType,
					account: account,
					// meter_code: code,
					start_time: startTime,
					end_time: endTime,
					is_export: '1',
					community_name:community_name,
					sort_by: this.prop,
					sort_to: this.order
				}, (data) => {
					window.location.href = data.url

				})
			},
			changeReceipt(row) {
				this.$jssdk.receipt.info({
					receipt_id: row.receipt_id
				}, (data) => {
					this.info_data = data
					this.infoShow = true
				})
			},
			changeReceiptEdit(row) {
				this.editId = row.receipt_id
				this.editShow = true
			},
			resetting() {
				this.select.account = ''
				// this.select.code = ''
				this.select.startTime = ''
				this.select.endTime = ''
				this.select.receiptType = ''
				this.select.type = ''
				this.select.status = ''
				this.select.sendType = ''
				this.select.address = ''
				this.select.community_name = ''
			},
			handleCurrentChange(val) {
				let account = this.select.account
				// let code = this.select.code
				let startTime = this.select.startTime
				let endTime = this.select.endTime
				let receiptType = this.select.receiptType
				let type = this.select.type
				let status = this.select.status
				let sendType = this.select.sendType
				var community_name = this.select.community_name
				this.$jssdk.receipt.list({
					receipt_type: receiptType,
					type: type,
					status: status,
					send_type: sendType,
					account: account,
					// meter_code: code,
					start_time: startTime,
					end_time: endTime,
					page: val,
					sort_by: this.prop,
					sort_to: this.order,
					community_name:community_name
				}, (data) => {
					this.lists = data.receiptList.data
					this.total = data.receiptList.total

				})
			},
			closeInfo() {
				this.infoShow = false
			},
			closeEdit() {
				this.editShow = false
				return this.search()
			},
		},
		components: {
			receiptInfo,
			receiptEdit
		}
	}
</script>

<style scoped="scoped">
	.add_meter_code {
		margin-bottom: 20px;
	}
</style>


// WEBPACK FOOTER //
// receipt.vue?26ea7974